export default __webpack_public_path__ + "static/safecheck-ready-2182a38756418b9366c52facf4322451.svg";